// @flow

import _ from 'lodash';
import React, { PureComponent } from 'react';

import { TeamLogo } from '@zapier/team';

import Avatar from 'app/common/components/Avatar';

type Props = {
  isTeam?: boolean,
  url: string,
  name: string,
  className?: string,
  size?: number,
};

export default class extends PureComponent<Props> {
  static defaultProps = {
    isTeam: false,
    size: 32,
  };

  render() {
    const { props } = this;
    const { isTeam } = props;
    const sharedProps = _.pick(props, ['url', 'className', 'size', 'name']);

    return isTeam ? <TeamLogo {...sharedProps} /> : <Avatar {...sharedProps} />;
  }
}
